(function(){
  function faq(){
    var pc=document.querySelector('.page-content');
    if(!pc||pc.dataset.llFaq) return;
    var h3=pc.querySelectorAll('h3');
    if(h3.length<4) return;
    pc.dataset.llFaq='1'; pc.classList.add('ll-faq');
    h3.forEach(function(h){
      var det=document.createElement('details');var sum=document.createElement('summary');sum.textContent=h.textContent;det.appendChild(sum);
      var n=h.nextElementSibling; h.parentNode.insertBefore(det,h); h.remove();
      while(n&&!/^H[1-3]$/.test(n.tagName)){var nx=n.nextElementSibling;det.appendChild(n);n=nx;}
    });
    var first=pc.querySelector('details'); if(first) first.open=true;
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',faq);else faq();
})();
